var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hot-table-main"},[_c('HotTable',{ref:"hottable",staticClass:"hot-table",attrs:{"root":_vm.root,"settings":_vm.hotSettings}}),_c('SubDataDetail',{ref:"subDataDetail"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }